import { removeHash, getHashProperty } from '../../../../design3/asset-build/js/custom/_utils';

/**
 * Gets all options defined in the property field
 */
function getAllOptionsFromPropertyField() {
	const options = [];

	$('#residenceRentalProperty option').each(function (index, optionElement) {
		options.push(optionElement.value);
	});

	return options;
}

export default function init() {
	if ($('.RentalsContactForm-Property').length > 0) {
		const properties = getAllOptionsFromPropertyField();
		const hashProperty = getHashProperty();
		const propertyExists =
			properties.find(property => property != '' && property === hashProperty) != undefined;

		if (propertyExists) {
			$('#residenceRentalProperty').val(hashProperty);
			$('#residenceRentalProperty').addClass('Dropdown-field--changed');
		} else {
			removeHash();
		}
	}
}
